<template>
  <IconAsset
    v-if="showUpgrade(config_type)"
    type="icon"
    upgrade="right"
    :noAsset="true"
    @upgrade="onUpgradeClick"
    @click="onUpgradeClick"
  >
    <template #text>
      {{ $t('dang-qian-quan-yi-zan-bu-zhi-chi-gai-zi-chan-ru-xu-jie-suo-qing') }}
    </template>
  </IconAsset>
</template>
<script lang="ts" setup>
import { ASSET_TYPE } from '@rendora/common/types/enums';
import { IconAsset } from '@rendora/design/widgets/icon-asset/index';
import { useUpgrade } from './useUpgrade';

const props = withDefaults(
  defineProps<{
    config_type?: number;
    tab?: 'character' | 'scene' | 'tts_vcn' | 'feature';
  }>(),
  {
    config_type: ASSET_TYPE.COMMON,
    position: 'topCenter',
    tab: 'character',
  },
);
const { showUpgrade, onUpgrade } = useUpgrade();

const emits = defineEmits(['cancel']);

const onUpgradeClick = () => {
  emits('cancel');
  onUpgrade(props.config_type);
};
</script>

<style lang="scss" scoped></style>
